import { AddressBar, type BreadcrumbSegment } from '@/components/ui/address-bar'
import { testIds } from '@/lib/test-ids'
import { dispatchNextcloudOpen } from './nextcloud-browse-events'

function crumbsFor(path: string): Array<{ label: string; path: string }> {
  const crumbs = [{ label: 'All files', path: '/' }]
  let acc = ''
  for (const part of path.split('/').filter(Boolean)) {
    acc += `/${part}`
    crumbs.push({ label: part, path: acc })
  }
  return crumbs
}

export function NextcloudDocumentCrumbs({
  path,
  organizationId,
  containerWidth,
}: {
  path: string
  organizationId?: string
  containerWidth: number | null
}) {
  const crumbs = crumbsFor(path)
  const segments: BreadcrumbSegment[] = crumbs.map((crumb) => ({
    label: crumb.label,
    path: crumb.path === path ? null : crumb.path,
    onClick:
      crumb.path === path || !organizationId
        ? undefined
        : () => {
            dispatchNextcloudOpen({
              organizationId,
              path: crumb.path,
              kind: 'folder',
              name: crumb.label,
            })
          },
  }))

  return (
    <div data-testid={testIds.nextcloud.documentCrumbs}>
      <AddressBar segments={segments} containerWidth={containerWidth} />
    </div>
  )
}
